'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var useMultistep = require('../hooks/useMultistep.js');
var useMultistepStep = require('../hooks/useMultistepStep.js');

var _excluded = ["children"],
  _excluded2 = ["render"],
  _excluded3 = ["children"];
function Multistep(_ref) {
  var children = _ref.children,
    props = _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);
  var _useMultistep = useMultistep.useMultistep(props),
    render = _useMultistep.render,
    context = _rollupPluginBabelHelpers.objectWithoutProperties(_useMultistep, _excluded2);
  if (typeof children === 'function') {
    return render(children(context));
  }
  return render(children);
}
Multistep.Step = function MultistepStep(_ref2) {
  var children = _ref2.children,
    props = _rollupPluginBabelHelpers.objectWithoutProperties(_ref2, _excluded3);
  var _useMultistepStep = useMultistepStep.useMultistepStep(props),
    render = _useMultistepStep.render;
  return render(children);
};

exports.Multistep = Multistep;
